import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getLegal, getAccount, acceptTerms } from "../lib/api";
import { AuthShell } from "./AuthShell";
import { TermsStepBody } from "./account/UserSetup";

// Site-wide forced acceptance after the owner announces policy changes (bumps the
// legal version + turns the gate on). Same screen as the Setup "Terms & Privacy" step.
export default function LegalGate() {
    const impersonating = typeof window !== "undefined" && !!localStorage.getItem("rosterly_owner_token");
    const loggedIn = typeof window !== "undefined" && !!localStorage.getItem("rosterly_token");
    const { data } = useQuery({ queryKey: ["legal"], queryFn: getLegal, staleTime: 5 * 60 * 1000 });
    const { data: account } = useQuery({ queryKey: ["account"], queryFn: getAccount, enabled: loggedIn, retry: false });
    const [agree, setAgree] = useState(false);
    const [done, setDone] = useState(false);
    const onAuthFlow = ["/login", "/setup"].includes(useLocation().pathname);

    const version = data?.version || 1;
    const accepted = localStorage.getItem(`rosterly_legal_v${version}`) === "yes" || (account?.profile?.accepted_legal_version || 0) >= version;
    if (!data || onAuthFlow || impersonating || !data.gate_enabled || accepted || done) return null;
    if (loggedIn && !account) return null;

    const accept = () => {
        try { localStorage.setItem(`rosterly_legal_v${version}`, "yes"); localStorage.setItem("rosterly_tos_agreed", "yes"); localStorage.setItem("rosterly_cookie_ack", "yes"); } catch { /* noop */ }
        setDone(true);
        if (loggedIn) acceptTerms(version).catch(() => {});
    };

    return (
        <AuthShell back={false} testId="legal-gate">
            <div className="text-center">
                <div className="text-[10px] font-black uppercase tracking-[0.2em] text-[#9D4CDD]" data-testid="legal-gate-kicker">Our policies have changed</div>
                <h1 className="font-heading text-2xl font-black uppercase tracking-tight mt-1">Terms &amp; Privacy</h1>
            </div>
            <div className="space-y-3"><TermsStepBody legal={data} agree={agree} setAgree={setAgree} /></div>
            <button type="button" disabled={!agree} onClick={accept} data-testid="legal-gate-accept-btn" className="btn-primary w-full disabled:opacity-40 disabled:cursor-not-allowed">Accept</button>
        </AuthShell>
    );
}
